module.exports = __webpack_public_path__ + "static/media/real-review-product.0af11f55.svg";